'use client';

import React from 'react';
import { useAccordionItem } from '../../context/AccordionProvider';
import { twMerge } from 'tailwind-merge';

export interface AccordionItemProps {
  children: React.ReactNode;
  index: number;
  className?: string;
  sx?: React.CSSProperties;
  onClick?: () => void;
}

interface ChildProps {
  isOpen?: boolean;
  onToggle?: () => void;
  index?: number;
}

const AccordionItem = ({
  children,
  index,
  className,
  sx,
  onClick,
}: AccordionItemProps) => {
  const { isOpen, onToggle } = useAccordionItem(index);

  const handleClick = () => {
    onToggle();
    onClick?.();
  };

  return (
    <div
      role="region"
      aria-labelledby={`accordion-item-${index}`}
      className={twMerge(className)}
      style={sx}
    >
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return null;

        return React.cloneElement(child as React.ReactElement<ChildProps>, {
          isOpen,
          onToggle: handleClick,
          index,
        });
      })}
    </div>
  );
};

export default AccordionItem;
